import { isJson } from './utils';

/* TODO - Review these codes returned by service
    Should not provide details like valid user
    Only not matching user/pass */
const AUTH_WRONG_PASSWORD_CODE_ERROR = 'auth/wrong-password';
const AUTH_USER_NOT_FOUND_CODE_ERROR = 'auth/user-not-found';
// What the Firebase SDK throws for the INVALID_LOGIN_CREDENTIALS server error
const AUTH_INVALID_CREDENTIAL_CODE_ERROR = 'auth/invalid-credential';
const AUTH_INVALID_EMAIL_CODE_ERROR = 'auth/invalid-email';
const AUTH_TOO_MANY_REQUESTS_CODE_ERROR = 'auth/too-many-requests';
const AUTH_INVALID_ACTION_CODE_ERROR = 'auth/invalid-action-code';
const AUTH_INVALID_VERIFICATION_CODE_ERROR = 'auth/invalid-verification-code';
const AUTH_CODE_EXPIRED_CODE_ERROR = 'auth/code-expired';
const AUTH_CREDENTIAL_ALREADY_IN_USE_ERROR = 'auth/credential-already-in-use';
const AUTH_PROVIDER_ALREADY_LINKED_ERROR = 'auth/provider-already-linked';
const AUTH_PASSWORD_POLICY_CODE_ERROR = 'auth/password-does-not-meet-requirements';

const AUTH_CODE_ERRORS = {
  [AUTH_WRONG_PASSWORD_CODE_ERROR]: true,
  [AUTH_USER_NOT_FOUND_CODE_ERROR]: true,
  [AUTH_INVALID_CREDENTIAL_CODE_ERROR]: true,
  [AUTH_INVALID_EMAIL_CODE_ERROR]: true,
};

const AUTH_INVALID_LOGIN_CREDENTIALS_MESSAGE = 'INVALID_LOGIN_CREDENTIALS';

const isAuthCredentialsError = (error) => {
  const { code, message } = error;

  return (
    AUTH_CODE_ERRORS[code] ||
    (
      isJson(message) &&
      JSON.parse(message).error?.message === AUTH_INVALID_LOGIN_CREDENTIALS_MESSAGE
    )
  );
};

const isTooManyRequestsError = (error) => {
  const { code } = error;

  return code === AUTH_TOO_MANY_REQUESTS_CODE_ERROR;
};

const isPasswordPolicyError = (error) => error?.code === AUTH_PASSWORD_POLICY_CODE_ERROR;

// On email-link sign-in the server rejects INVALID_EMAIL when the typed email is
// not the one the link was sent to; the link itself is not consumed.
const isInvalidEmailError = (error) => error?.code === AUTH_INVALID_EMAIL_CODE_ERROR;

const EMAIL_LINK_MISMATCH_ERROR = 'This email doesn’t match the one that received the link. Please check it and try again.';

const isInvalidActionError = (error) => {
  const { code } = error;

  return code === AUTH_INVALID_ACTION_CODE_ERROR;
};

const isInvalidVerificationCodeError = (error) => {
  const { code } = error;

  return code === AUTH_INVALID_VERIFICATION_CODE_ERROR;
};

const isCodeExpiredError = (error) => {
  const { code } = error;

  return code === AUTH_CODE_EXPIRED_CODE_ERROR;
};

const isPhoneAlreadyLinkedError = (error) => {
  const { code } = error;

  return (
    code === AUTH_CREDENTIAL_ALREADY_IN_USE_ERROR ||
    code === AUTH_PROVIDER_ALREADY_LINKED_ERROR
  );
};

const GENERIC_CODE_ERROR = 'TR-GC-001';
const PHONE_ALREADY_VERIFIED_ERROR = 'TR-PE-003';
const NOT_FOUND_ERROR = 'TR-PE-004';
const REWARDS_FUNDS_CODE_ERROR = 'TR-PE-005';
const REWARDS_NO_MORE_CODES = 'TR-PE-006';
const REWARDS_NO_MORE_CODES_PER_USER = 'TR-PE-007';
const REWARDS_LOCKED_CODE_ERROR = 'TR-PE-008';
const GIFT_CARDS_FUNDS_CODE_ERROR = 'TR-PE-020';
const TAKE_BACK_BAG_NOT_AUTHORIZED = 'TR-AU-001';
const PAYMENT_STATUS_ERROR = 'TR-SP-003';
const EVENT_TICKET_ALREADY_CLAIMED_ERROR = 'TR-EV-003';
const REDEMPTION_CODE_NOT_FOUND = 'FD-R-011';
const REDEMPTION_CODE_BLOCKED = 'FD-R-012';
const CART_ERROR = 'TR-PE-023';
// TR-PE-024 intentionally omitted from errorCodes — message is sourced from the backend response
const LABEL_GENERATION_ERROR = 'TR-PE-024';
// TR-AU-004 — the member's renewal payment is failing, so membership benefits
// (free registration, claiming bags) are suspended until the card is fixed. The
// backend message is written for customers; the fix is a card update, not a retry.
const SUBSCRIPTION_PAYMENT_REQUIRED_CODE = 'TR-AU-004';
// Account takeover hardening: phone step-up on gift card redemption and the
// email code required to enroll a phone.
const MFA_REQUIRED_ERROR = 'TR-AU-003';
const STEP_UP_REQUIRED_ERROR = 'TR-AU-005';
const STEP_UP_INVALID_ERROR = 'TR-AU-006';
const STEP_UP_PHONE_MISMATCH_ERROR = 'TR-AU-007';
const EMAIL_CODE_REQUIRED_ERROR = 'TR-AU-008';
const EMAIL_CODE_INVALID_ERROR = 'TR-AU-009';
const SECURITY_CODE_RATE_LIMITED_ERROR = 'TR-AU-010';
const CURRENT_PHONE_REQUIRED_ERROR = 'TR-AU-012';
// details.holdUntil carries the end of the hold; copy is built where it's shown.
const REDEMPTION_HOLD_ERROR = 'TR-PE-030';
const GIFT_CARD_VELOCITY_LIMIT_ERROR = 'TR-PE-031';
const SHIPPING_LABEL_GENERIC_ERROR = "We're unable to generate a shipping label. Please try again. If the issue persists, contact support.";

const errorCodes = {
  [GENERIC_CODE_ERROR]: 'Something went wrong. Please try again later or contact support.',
  [PHONE_ALREADY_VERIFIED_ERROR]: 'This phone number is already registered with another account. Please use a different number or contact support.',
  [NOT_FOUND_ERROR]: 'Not found.',
  [REWARDS_FUNDS_CODE_ERROR]: 'Insufficient funds',
  [REWARDS_NO_MORE_CODES]: 'No more codes available for that reward.',
  [REWARDS_NO_MORE_CODES_PER_USER]: 'No more codes available for this user for this reward',
  [REWARDS_LOCKED_CODE_ERROR]: 'Locked for this user',
  [GIFT_CARDS_FUNDS_CODE_ERROR]: 'Insufficient funds',
  [TAKE_BACK_BAG_NOT_AUTHORIZED]: 'THE BAG CODE YOU ARE TRYING TO REGISTER WAS ALREADY REGISTERED BY ANOTHER ACCOUNT',
  [PAYMENT_STATUS_ERROR]: 'A payment for this Take Back Bag has been made by a different user. Please review and try again or contact support.',
  [REDEMPTION_CODE_NOT_FOUND]: 'The bag code you are trying to redeem was not found in our records, if you think this is an error please contact support.',
  [MFA_REQUIRED_ERROR]: 'Please verify your phone number to continue.',
  [STEP_UP_REQUIRED_ERROR]: 'Please confirm your phone number to get your gift card.',
  [STEP_UP_INVALID_ERROR]: 'Your verification expired. Please request a new code.',
  [STEP_UP_PHONE_MISMATCH_ERROR]: 'That isn\'t the phone number on your account.',
  [EMAIL_CODE_REQUIRED_ERROR]: 'Please enter the code we sent to your email.',
  [EMAIL_CODE_INVALID_ERROR]: 'Invalid code. Verify it and try again or get a new code.',
  [CURRENT_PHONE_REQUIRED_ERROR]: 'To change your phone number, contact support.',
  [GIFT_CARD_VELOCITY_LIMIT_ERROR]: 'You\'ve reached today\'s gift card limit. Please try again tomorrow.',

};

const getGenericError = () => errorCodes[GENERIC_CODE_ERROR];

export {
  errorCodes,
  getGenericError,
  isAuthCredentialsError,
  isTooManyRequestsError,
  isInvalidActionError,
  isPasswordPolicyError,
  isInvalidEmailError,
  EMAIL_LINK_MISMATCH_ERROR,
  GENERIC_CODE_ERROR,
  PHONE_ALREADY_VERIFIED_ERROR,
  NOT_FOUND_ERROR,
  REWARDS_FUNDS_CODE_ERROR,
  REWARDS_NO_MORE_CODES,
  REWARDS_NO_MORE_CODES_PER_USER,
  REWARDS_LOCKED_CODE_ERROR,
  GIFT_CARDS_FUNDS_CODE_ERROR,
  EVENT_TICKET_ALREADY_CLAIMED_ERROR,
  REDEMPTION_CODE_NOT_FOUND,
  REDEMPTION_CODE_BLOCKED,
  CART_ERROR,
  LABEL_GENERATION_ERROR,
  SUBSCRIPTION_PAYMENT_REQUIRED_CODE,
  SHIPPING_LABEL_GENERIC_ERROR,
  MFA_REQUIRED_ERROR,
  STEP_UP_REQUIRED_ERROR,
  STEP_UP_INVALID_ERROR,
  STEP_UP_PHONE_MISMATCH_ERROR,
  EMAIL_CODE_REQUIRED_ERROR,
  EMAIL_CODE_INVALID_ERROR,
  SECURITY_CODE_RATE_LIMITED_ERROR,
  REDEMPTION_HOLD_ERROR,
  GIFT_CARD_VELOCITY_LIMIT_ERROR,
  isInvalidVerificationCodeError,
  isCodeExpiredError,
  isPhoneAlreadyLinkedError,
};
